import { Provider } from "@angular/core";
import { Observable } from "rxjs";
import { UseCase } from "../../../core/use-case";

import { FreezeCost } from "../../models/costs.model";
import { HrRepository } from "../../repositories/hr.repository";

export class FreezeCostsUseCase implements UseCase<number, FreezeCost[]> {
  constructor(private repo: HrRepository) {}

  execute(param: number): Observable<FreezeCost[]> {
    return this.repo.retrieveFreezeCosts(param);
  }
}

const freezeCostsUseCaseFactory = (repo: HrRepository) =>
  new FreezeCostsUseCase(repo);

export const freezeCostsUseCaseProvider: Provider = {
  provide: FreezeCostsUseCase,
  useFactory: freezeCostsUseCaseFactory,
  deps: [HrRepository],
};
